var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"locale":_vm.locale,"id":_vm.id,"moduleIndex":_vm.moduleIndex,"item":_vm.item,"itemSetting":_vm.itemSetting,"activeLang":_vm.activeLang,"hasPrice":_vm.hasPrice,"subOption":_vm.subOption},on:{"setDetail":_vm.setDetails}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }